import { render, staticRenderFns } from "./LTable.vue?vue&type=template&id=364cfdb8&scoped=true"
import script from "./LTable.vue?vue&type=script&lang=js"
export * from "./LTable.vue?vue&type=script&lang=js"
import style0 from "./LTable.vue?vue&type=style&index=0&id=364cfdb8&prod&lang=scss"
import style1 from "./LTable.vue?vue&type=style&index=1&id=364cfdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364cfdb8",
  null
  
)

export default component.exports